import { useState } from 'react';

/**
 * Custom hook for managing confirmation dialogs
 * @returns {Object} - Object containing dialog state and control functions
 */
export const useConfirmationDialog = () => {
  const [dialog, setDialog] = useState({
    open: false,
    title: '',
    message: '',
    onConfirm: null,
    severity: 'warning',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
  });

  const openDialog = ({
    title,
    message,
    onConfirm,
    severity = 'warning',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
  }) => {
    setDialog({
      open: true,
      title,
      message,
      onConfirm,
      severity,
      confirmText,
      cancelText,
    });
  };

  const closeDialog = () => {
    setDialog({
      open: false,
      title: '',
      message: '',
      onConfirm: null,
      severity: 'warning',
      confirmText: 'Confirm',
      cancelText: 'Cancel',
    });
  };

  const showDeleteConfirmation = (itemName, onConfirm) => {
    openDialog({
      title: 'Delete Confirmation',
      message: `Are you sure you want to delete "${itemName}"? This action cannot be undone.`,
      severity: 'error',
      confirmText: 'Delete',
      cancelText: 'Cancel',
      onConfirm,
    });
  };

  const showWarningConfirmation = (title, message, onConfirm) => {
    openDialog({
      title,
      message,
      severity: 'warning',
      confirmText: 'Continue',
      cancelText: 'Cancel',
      onConfirm,
    });
  };

  const showInfoConfirmation = (title, message, onConfirm) => {
    openDialog({
      title,
      message,
      severity: 'info',
      confirmText: 'OK',
      cancelText: 'Cancel',
      onConfirm,
    });
  };

  return {
    dialog,
    openDialog,
    closeDialog,
    showDeleteConfirmation,
    showWarningConfirmation,
    showInfoConfirmation,
  };
};

export default useConfirmationDialog;
